import React, { useState, useEffect } from 'react';
import { withRouter, Link, useLocation } from "react-router-dom";
import { Checkbox, Form, Input, Row, Typography } from 'antd';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';


import {
    Grid,
} from "@material-ui/core";

import 'antd/dist/antd.css';
import { useUserDispatch, loginUser, forgotPassword } from "../../context/UserContext";
//Components
import { CustomBtn } from '../../components/UiElements/UiElements';

import Logo from '../../assets/img/app-login-logo.svg';
import { withSnackbar } from "./../../components/Message/Alert";
import { handleNumberKeyPress } from '../../../src/components/Common/Extensions';
import MultipleAccount from './multipleAccount/LoginMultipleAccount'

//styles
import './style.css';
function Login(props) {
    const { showMessage } = props;
    const [form] = Form.useForm();
    // global
    var userDispatch = useUserDispatch();
    // local
    var [isLoading, setIsLoading] = useState(false);
    var [rememberMe, setRememberMe] = useState(false);
    var [error, setError] = useState(null);
    var [isSuccess, setIsSuccess] = useState(false);
    var [returnMessage, setReturnMessage] = useState("");

    const [activeTabId, setActiveTabId] = useState(0);

    var [validateEmail, setValidateEmail] = useState(false);
    var [validateAccount, setValidateAccount] = useState(false);
    var [validatePhoneNumber, setValidatePhoneNumber] = useState(false);
    var [userId, setUserId] = useState("");
    var [loginValue, setLoginValue] = useState("");
    var [userType, setUserType] = useState("");
    var [passwordValue, setPasswordValue] = useState("");
    var [forgetPasswordValue, setForgetPasswordValue] = useState("");
    var [resetButtonDisalbed, setResetButtonDisalbed] = useState(false);
    var [multipleAccounts, setMultipleAccounts] = useState([]);
    const [showMultipleAccountDialog, setShowMultipleAccountDialog] = useState(false);

    const handleCloseMultipleAccount = () => {
        setShowMultipleAccountDialog(false)
    }

    const openMultipleAccountDialog = () => {
        setShowMultipleAccountDialog(true)
    }

    const loadAccount = (account) => {
        handleCloseMultipleAccount();
        setAuthenticateBy();
        setUserId(account.userId);
        setLoginValue(account.userId);
        setUserType(account.userType);
        setIsLoading(false);
        setError(false);
        setReturnMessage("");

        loginUser(
            userDispatch,
            account.userId,
            account.userId,
            account.userType,
            3,
            passwordValue,
            props.history,
            setIsLoading,
            setError,
            setReturnMessage,
            showMultipleAccounts
        )
    }

    const [selectedTab, setSelectedTab] = React.useState(0);


    const location = useLocation();
    //AccountNumber
    //Email
    //MDNNumber
    const [authenticateBy, setAuthenticateBy] = useState(0);
    const handleChange = e => {
        const { name, value } = e.target;
        setForgetPasswordValue(value)
        setIsSuccess(false)
    }
    const handleCheckboxChange = (e) => {

    }

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }


    const onBlurAccountNumber = (event) => {
        let accountNumber = event;

        if (accountNumber && !/[0-9]/.test(accountNumber)) {
            setValidateAccount(true);
        }
        else
            setValidateAccount(false);
    };

    const onBlurEmail = (event) => {
        let emailadd = event;

        if (emailadd && !/^((?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\]))$/i.test(emailadd)) {
            setValidateEmail(true);
        }
        else
            setValidateEmail(false);
    };


    const formatPhoneNumber = (input) => {
        // Remove all non-digit characters from the input
        const cleanInput = input.replace(/\D/g, '');
        // Format the phone number using regex groups
        const formattedPhoneNumber = cleanInput.replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');
        return formattedPhoneNumber;
    };
    const handleMDNChange = (event) => {
        const inputValue = event.target.value;
        const formattedValue = formatPhoneNumber(inputValue);
        setLoginValue(formattedValue);
    };
    const onBlurMdnNumber = (event) => {
        let phoneNumber = event;

        const cleanInput = phoneNumber.replace(/\D/g, '');

        if (cleanInput && cleanInput.length != 10) {
            setValidatePhoneNumber(true);
        }
        else
            setValidatePhoneNumber(false);
    };
    const onTabChange = (value) => {

        setActiveTabId(value);
        setValidateAccount(false);
        setValidateEmail(false);
        setResetButtonDisalbed(false);
        setError(false);
        // setIsSuccess(false);
        setReturnMessage("");
        setForgetPasswordValue("");
    };

    const onTabChangeBack = (value) => {
        setActiveTabId(value);
        setValidateAccount(false);
        setValidateEmail(false);
        setResetButtonDisalbed(false);
        setError(false);
        // setIsSuccess(false);
        setReturnMessage("");
        setLoginValue("");
        setPasswordValue("");
    }
    const AuthenticateTabChange = (e, newValue) => {
        debugger
        setAuthenticateBy(newValue)
        setLoginValue('');
        setPasswordValue('');
    }

    const showMultipleAccounts = (data) => {
        setMultipleAccounts(data);
        openMultipleAccountDialog();
        setIsLoading(false);
        setError(false);
        setReturnMessage("");
    }

    function submitLoginUser() {
        loginUser(
            userDispatch,
            '',
            loginValue,
            '',
            authenticateBy,
            passwordValue,
            props.history,
            setIsLoading,
            setError,
            setReturnMessage,
            showMultipleAccounts
        )

    }

    //     function successCase(isSuccess, msg) {
    //         if(isSuccess) {
    //         return showMessage("Success", msg, "success", 5000);
    //     }
    //     else {
    //         return showMessage("Error", msg, "error", 5000);
    //     }
    // }

    useEffect(() => {
        if (sessionStorage.getItem('resetPassword')) {
            showMessage("Success", "Your password has been reset successfully", "success", 4000)
            sessionStorage.removeItem("resetPassword");
        }
        // Retrieve the input value from local storage when the component mounts
        //const storedForgetPasswordValue = localStorage.getItem('forgetPasswordValue');
        //if (storedForgetPasswordValue) {
        //    localStorage.removeItem('forgetPasswordValue');
        //    setLoginValue(storedForgetPasswordValue);
        //}

        const storedAuthenticatedBy = localStorage.getItem('authenticatedBy');
        if (storedAuthenticatedBy) {
            localStorage.removeItem('authenticatedBy');
            setAuthenticateBy(storedAuthenticatedBy === "3" ? 2 : parseInt(storedAuthenticatedBy));
        }

    }, []);

    return (
        <div className="login-main">
            <div className="login-form-area">
                <div className='login-left-panel'>
                    <img alt="logo" src={Logo} />
                </div>
                <div className="login-right-panel">
                    <div className="login-form-custom">
                        <div className="login-logo">
                            <img alt="logo" src={Logo} />
                        </div>
                        {activeTabId === 0 &&
                            (
                                <Form className="login-form" layout="vertical" onFinish={submitLoginUser} form={form}
                                    scrollToFirstError>

                                    <Grid row container className="LoginTabUi">
                                        <Tabs value={authenticateBy} onChange={(e, newValue) => AuthenticateTabChange(e, newValue)} variant="scrollable"
                                            scrollButtons={true} allowScrollButtonsMobile>
                                            <Tab label="Phone Number" aria-label="Phone Number" {...a11yProps(0)} />
                                            <Tab label="Acc Number" aria-label="Account" {...a11yProps(1)} />
                                            <Tab label="Email" aria-label="Email" {...a11yProps(2)} />
                                        </Tabs>
                                    </Grid>
                                    <React.Fragment>
                                        <>
                                            {authenticateBy === 0 &&
                                                <div>
                                                    <Form.Item className="login-label" rules={[{ required: true }]}  >
                                                        <Input
                                                            className="login-input"
                                                            value={loginValue}
                                                            onChange={handleMDNChange}
                                                            placeholder="Phone Number"
                                                            type="text"
                                                            onBlur={(e) => onBlurMdnNumber(e.target.value)}
                                                            autoComplete={"off"}
                                                            maxLength={"14"}
                                                        />
                                                        {validatePhoneNumber ? (
                                                            <Typography color="secondary" className="error-message"> Invalid phone number </Typography>
                                                        ) : ("")
                                                        }
                                                    </Form.Item>
                                                </div>

                                            }
                                            {authenticateBy === 1 &&
                                                <div>
                                                    <Form.Item className="login-label" rules={[{ required: true }]}  >
                                                        <Input
                                                            className="login-input"
                                                            value={loginValue}
                                                            onChange={e => setLoginValue(e.target.value)}
                                                            placeholder="Account Number"
                                                            type="text"
                                                            onBlur={(e) => onBlurAccountNumber(e.target.value)}
                                                            autoComplete={"off"}
                                                            maxLength={"20"}
                                                            onKeyPress={(e) => handleNumberKeyPress(e)}
                                                        />
                                                        {validateAccount ? (
                                                            <Typography color="secondary" className="error-message"> Invalid account number </Typography>
                                                        ) : ("")
                                                        }
                                                    </Form.Item>
                                                </div>
                                            }
                                            {authenticateBy === 2 &&
                                                <div>
                                                    <Form.Item className="login-label" rules={[{ required: true }]}  >
                                                        <Input
                                                            className="login-input"
                                                            value={loginValue}
                                                            onChange={e => setLoginValue(e.target.value)}
                                                            placeholder="Email"
                                                            type="text"
                                                            onBlur={(e) => onBlurEmail(e.target.value)}
                                                            autoComplete={"off"}
                                                            maxLength={"100"}
                                                        />
                                                        {validateEmail ? (
                                                            <Typography color="secondary" className="error-message"> Invalid email address </Typography>
                                                        ) : ("")
                                                        }
                                                    </Form.Item>
                                                </div>
                                            }


                                            <Form.Item className="login-label" rules={[{ required: true }]}>
                                                <Input.Password
                                                    className="login-input"
                                                    type="password"
                                                    value={passwordValue}
                                                    onChange={e => setPasswordValue(e.target.value)}
                                                    placeholder="Password"
                                                    autoComplete="off"
                                                    maxLength={50}
                                                    iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                                />
                                                {error ? (
                                                    <Typography color="secondary" className="error-message"> {returnMessage} </Typography>
                                                ) : ("")
                                                }
                                            </Form.Item>


                                            <Row className="login-form-forgot-password">
                                                <Grid container direction='row' justifyContent='space-between'>
                                                    <Grid item lg={6}>
                                                        <Checkbox
                                                            name="rememberMe"
                                                            value={rememberMe}
                                                            className='remember-me'
                                                            onChange={(e) => setRememberMe(e.target.checked)}
                                                        >Remember me</Checkbox>
                                                    </Grid>
                                                    <Grid item lg={6}>
                                                        {/* <Form.Item > */}
                                                        <Link
                                                            className="createAccountText"
                                                            onClick={() => onTabChange(1)}
                                                            style={{ float: 'right', width: 'fit-content' }}>
                                                            Forgot password?
                                                        </Link>
                                                        {/* </Form.Item> */}
                                                    </Grid>
                                                </Grid>
                                            </Row>


                                        </>
                                        <Row className="login-form-submit-btn">
                                            {isLoading ?
                                                <CustomBtn
                                                    id="saveLoading"
                                                    btnType="primary"
                                                    htmlType="submit"
                                                    shape="round"
                                                    loading={isLoading}
                                                    size="small" > Login</CustomBtn> :
                                                <CustomBtn
                                                    id="save"
                                                    btnType="primary"
                                                    htmlType="submit"
                                                    shape="round"
                                                    isDisabled={passwordValue.length === 0 || loginValue.length === 0 ? true : false}
                                                    size="small" > Login</CustomBtn>}
                                        </Row>


                                    </React.Fragment>
                                </Form>

                            )
                        }
                        {activeTabId === 1 &&
                            (<Form
                                className="login-form"
                                layout="vertical" onFinish={() => forgotPassword(
                                    forgetPasswordValue,
                                    props.history,
                                    setIsLoading,
                                    setError,
                                    setIsSuccess,
                                    setReturnMessage,
                                    setResetButtonDisalbed,
                                    props

                                )}
                                form={form}
                                scrollToFirstError>
                                <React.Fragment>
                                    <>
                                        <Typography className="forgot-title">Forgot your Password ?</Typography>
                                        <Typography>
                                            We will send you a password reset link via email.
                                        </Typography>
                                        <Form.Item className="login-label" rules={[{ required: true }]}  >
                                            <Input
                                                className="login-input"
                                                value={forgetPasswordValue}
                                                onChange={handleChange}
                                                placeholder="Email"
                                                type="text"
                                                onBlur={(e) => onBlurEmail(e.target.value)}
                                                autoComplete={"off"}
                                                maxLength={"100"}
                                            />
                                            {validateEmail ? (
                                                <Typography color="secondary" className="error-message"> Invalid Email Address </Typography>
                                            ) : ("")
                                            }
                                        </Form.Item>
                                        <Typography>
                                            If you do not have access to your email, please contact your system administrator to have your password reset.
                                        </Typography>

                                        <Row>
                                            {error ? (
                                                <Typography color="secondary" className="error-message"> Email Address Not Found </Typography>
                                            ) : ("")
                                            }
                                            {/* {isSuccess ? (
                                                <Typography color="primary" className="success-message">
                                                    {returnMessage}
                                                </Typography>
                                            ) : ("")
                                            } */}
                                        </Row>



                                    </>
                                    <Row className="login-form-submit-btn">

                                        {isLoading ?
                                            <CustomBtn
                                                id="saveLoading"
                                                btnType="primary"
                                                htmlType="submit"
                                                shape="round"
                                                loading={isLoading}
                                                size="default"
                                            > Reset password </CustomBtn> :
                                            <CustomBtn
                                                id="save"
                                                btnType="primary"
                                                htmlType="submit"
                                                shape="round"
                                                isDisabled={forgetPasswordValue.length === 0 ? true : false}
                                                size="default"
                                            > Reset password </CustomBtn>
                                        }
                                    </Row>
                                    <Row className="login-form-forgot-password">
                                        <Form.Item onClick={() => onTabChangeBack(0)}> <Link className="login-form-forgot-label" > Back to login </Link></Form.Item>
                                    </Row>
                                </React.Fragment>
                            </Form>)}
                        <Typography className="footerContent">Please note this application may only be accessed by
                            authorized users. Each user can only view data associated with their specific account.
                            {/*By logging in,*/}
                            {/*you are accepting our Terms of Services. To find out how we protect your information, view our <Link className="login-form-get-registered">Privacy Policy</Link>.*/}
                            <br />
                            <span className="copyright">© {new Date().getFullYear()} Figgers Communication Inc.</span>
                        </Typography>
                    </div>
                </div>

            </div>
            {showMultipleAccountDialog ? <MultipleAccount
                dialogOpenClose={showMultipleAccountDialog}
                handleClose={handleCloseMultipleAccount}
                handleMultipleAccountLoad={loadAccount}
                accounts={multipleAccounts}
            ></MultipleAccount> : ''}
        </div>
    )
}
export default withRouter(withSnackbar(Login));
